(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["planes-precios"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initPlanesToggle(section) {
    var btns = section.querySelectorAll('.toggle-btn');
    var prices = section.querySelectorAll('.plan-card__price');

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var period = this.getAttribute('data-period');

        btns.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');

        prices.forEach(function(el) {
          el.style.opacity = '0';
          setTimeout(function() {
            el.textContent = period === '1'
              ? el.getAttribute('data-prices-1')
              : el.getAttribute('data-prices-2');
            el.style.opacity = '1';
          }, 120);
        });
      });
    });
  }

  document.querySelectorAll('.planes-section').forEach(initPlanesToggle);

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section.querySelector('.planes-section')) {
      initPlanesToggle(section.querySelector('.planes-section'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
